import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { BrowserRouter } from "react-router-dom";
// import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
Amplify.configure(awsExports);

// try {
//   const config: AwsRumConfig = {
//     sessionSampleRate: 1,
//     identityPoolId: "ap-southeast-1:20be878e-3122-41d2-aa1f-ebb5367e49df",
//     endpoint: "https://dataplane.rum.ap-southeast-1.amazonaws.com",
//     telemetries: ["performance", "errors", "http"],
//     allowCookies: true,
//     enableXRay: false,
//   };

//   const APPLICATION_ID: string = "47346307-4ede-4d87-893d-0dfab8cf0107";
//   const APPLICATION_VERSION: string = "1.0.0";
//   const APPLICATION_REGION: string = "ap-southeast-1";

//   const awsRum: AwsRum = new AwsRum(
//     APPLICATION_ID,
//     APPLICATION_VERSION,
//     APPLICATION_REGION,
//     config
//   );
//   console.log("awsRum : ", awsRum);
// } catch (error) {
//   // Ignore errors thrown during CloudWatch RUM web client initialization
// }

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
